"use client";

import { Box, Grid } from "@mui/material";

import { UserBase } from "@/types/user";

import { useLookup } from "@/context/lookup";

import { getLookupAlert } from "@/components/alerts/global";
import LoginButton from "@/components/loginButton";
import LookupForm from "@/components/lookup/form";
import LookupButton from "@/components/lookup/button";

export default function PinLookup() {
  const {
    errors,
    getUserPin,
    lookupUser,
    pinSuccess,
    setErrors,
    setLookupUser,
  } = useLookup();

  return !pinSuccess ? (
    <Box mt={2}>
      {!pinSuccess && getLookupAlert()}
      <LookupForm<UserBase>
        entity={lookupUser}
        errors={errors}
        set={setLookupUser}
        setErrors={setErrors}
        title="Find My User Pin"
      />
      <Grid container justifyContent="flex-end">
        <Grid display="flex" justifyContent="flex-end !important">
          <LookupButton<UserBase>
            entity={lookupUser}
            errors={errors}
            onClick={getUserPin}
            tooltipSuffix="to send your pin"
          />
        </Grid>
      </Grid>
    </Box>
  ) : (
    <LoginButton />
  );
}
